(function () {
  var button = document.querySelector('.yt-menu');
  var nav = document.getElementById('YtNav');
  if (button && nav) {
    button.addEventListener('click', function () {
      var isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('is-open', !isOpen);
    });
    nav.addEventListener('click', function (event) {
      if (event.target.tagName === 'A') {
        button.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
      }
    });
  }
})();
(function () {
  var gallery = document.querySelector('.yt-product-gallery');
  if (!gallery) return;
  var main = gallery.querySelector('#YtProductGalleryMain');
  var buttons = gallery.querySelectorAll('[data-yt-gallery-src]');
  if (!main || !buttons.length) return;
  Array.prototype.forEach.call(buttons, function (button) {
    button.addEventListener('click', function () {
      main.src = button.getAttribute('data-yt-gallery-src');
      main.alt = button.getAttribute('data-yt-gallery-alt') || '';
      Array.prototype.forEach.call(buttons, function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', String(active));
      });
    });
  });
})();
(function () {
  var forms = document.querySelectorAll('.yt-plan-card form[action*="/cart/add"]');
  if (!forms.length) return;
  var overlay = document.createElement('div');
  overlay.className = 'yt-cart-transition';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.innerHTML = '<div class="yt-cart-transition__card" role="status" aria-live="polite"><img src="https://cdn.shopify.com/s/files/1/0293/0963/2647/files/your-team-isotipo-transparente-2026.png?v=1787675138" alt=""><b>Preparando tu plan...</b><small>Te llevamos al carrito</small><div class="yt-cart-transition__bar"><i></i></div></div>';
  document.body.appendChild(overlay);
  Array.prototype.forEach.call(forms, function (form) {
    form.addEventListener('submit', function () {
      var submit = form.querySelector('button[type="submit"]');
      if (submit) {
        submit.setAttribute('aria-busy', 'true');
        submit.classList.add('is-loading');
      }
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
    });
  });
  window.addEventListener('pageshow', function () {
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    Array.prototype.forEach.call(forms, function (form) {
      var submit = form.querySelector('button[type="submit"]');
      if (submit) {
        submit.removeAttribute('aria-busy');
        submit.classList.remove('is-loading');
      }
    });
  });
})();
(function () {
  var cart = document.querySelector('.yt-cart--enhanced');
  if (!cart || !window.fetch) return;
  var currency = cart.getAttribute('data-yt-cart-currency') || 'USD';

  function money(cents) {
    if (currency === 'USD') return '$' + (cents / 100).toFixed(2);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function setNavigationCount(count) {
    var badge = document.querySelector('.yt-cart-link span');
    if (badge) badge.textContent = count;
    var counter = cart.querySelector('[data-yt-cart-count]');
    if (counter) counter.textContent = count + (count === 1 ? ' selección' : ' selecciones');
  }

  function setBusy(row, busy, message) {
    row.classList.toggle('is-updating', busy);
    Array.prototype.forEach.call(row.querySelectorAll('.yt-qty-control button, .yt-remove-button'), function (control) {
      control.setAttribute('aria-disabled', String(busy));
      if (control.tagName === 'BUTTON') control.disabled = busy;
    });
    var status = row.querySelector('.yt-qty-status');
    if (status) status.textContent = message || '';
  }

  function restoreButtons(row) {
    var input = row.querySelector('[data-yt-qty-input]');
    var minus = row.querySelector('[data-yt-qty="-1"]');
    Array.prototype.forEach.call(row.querySelectorAll('.yt-qty-control button'), function (button) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    });
    if (minus && input) minus.disabled = Number(input.value) <= 1;
    var remove = row.querySelector('.yt-remove-button');
    if (remove) remove.removeAttribute('aria-disabled');
  }

  function changeLine(row, quantity, removing) {
    var line = Number(row.getAttribute('data-yt-cart-line'));
    var input = row.querySelector('[data-yt-qty-input]');
    var previous = Number(input.value);
    setBusy(row, true, removing ? 'Eliminando...' : 'Actualizando...');

    window.fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('No se pudo actualizar el carrito');
      return response.json();
    }).then(function (updatedCart) {
      setNavigationCount(updatedCart.item_count);
      var total = cart.querySelector('[data-yt-cart-total]');
      if (total) total.textContent = money(updatedCart.total_price);

      if (quantity === 0) {
        row.classList.remove('is-updating');
        row.classList.add('is-removing');
        window.setTimeout(function () { window.location.reload(); }, 260);
        return;
      }

      var updatedItem = updatedCart.items[line - 1];
      if (!updatedItem) {
        window.location.reload();
        return;
      }
      input.value = updatedItem.quantity;
      var lineTotal = row.querySelector('[data-yt-line-total]');
      if (lineTotal) lineTotal.textContent = money(updatedItem.final_line_price);
      setBusy(row, false, 'Actualizado');
      restoreButtons(row);
      row.classList.add('is-updated');
      window.setTimeout(function () {
        row.classList.remove('is-updated');
        var status = row.querySelector('.yt-qty-status');
        if (status) status.textContent = '';
      }, 700);
    }).catch(function () {
      input.value = previous;
      setBusy(row, false, 'No se pudo actualizar. Intenta otra vez.');
      restoreButtons(row);
    });
  }

  cart.addEventListener('click', function (event) {
    var quantityButton = event.target.closest('[data-yt-qty]');
    if (quantityButton && cart.contains(quantityButton)) {
      event.preventDefault();
      if (quantityButton.disabled || quantityButton.getAttribute('aria-disabled') === 'true') return;
      var row = quantityButton.closest('[data-yt-cart-line]');
      var input = row.querySelector('[data-yt-qty-input]');
      var next = Math.max(1, Number(input.value) + Number(quantityButton.getAttribute('data-yt-qty')));
      if (next !== Number(input.value)) changeLine(row, next, false);
      return;
    }

    var removeButton = event.target.closest('[data-yt-remove-line]');
    if (removeButton && cart.contains(removeButton)) {
      event.preventDefault();
      if (removeButton.getAttribute('aria-disabled') === 'true') return;
      changeLine(removeButton.closest('[data-yt-cart-line]'), 0, true);
    }
  });
})();